import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { detectUsState } from "@/lib/geo";
import { toast } from "sonner";

export default function AuthCallback() {
    const nav = useNavigate();
    const { setUser } = useAuth();
    const [status, setStatus] = useState("Connecting…");

    useEffect(() => {
        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
        const sessionId = params.get("session_id");
        if (!sessionId) {
            setStatus("No session_id found — redirecting…");
            const t = setTimeout(() => nav("/login"), 1500);
            return () => clearTimeout(t);
        }
        (async () => {
            try {
                const r = await api.post("/auth/google/session", { session_id: sessionId });
                let userData = r.data.user;
                // Auto-detect state on first Google sign-in if user has no state (or was defaulted to KY without touching)
                if (!userData.state || userData.state === "KY") {
                    const detected = await detectUsState();
                    if (detected && detected !== userData.state) {
                        try {
                            await api.post("/auth/state", { state: detected });
                            const me = await api.get("/auth/me");
                            userData = me.data;
                        } catch {}
                    }
                }
                setUser?.(userData);
                window.history.replaceState({}, document.title, "/");
                toast.success(`Welcome, /${userData.gamer_tag}`);
                nav(`/player/${encodeURIComponent(userData.gamer_tag)}`);
            } catch (e) {
                setStatus(e?.response?.data?.detail || "Google sign-in failed");
                setTimeout(() => nav("/login"), 2200);
            }
        })();
    }, [nav, setUser]);

    return (
        <div className="pt-40 pb-40 text-center" data-testid="auth-callback-page">
            <div className="overline text-white/40 mb-4">[ Google sign-in ]</div>
            <h1 className="font-display font-black text-4xl md:text-5xl">Signing you in…</h1>
            <p className="mt-6 font-mono text-[11px] tracking-[0.28em] uppercase text-white/50" data-testid="auth-callback-status">{status}</p>
        </div>
    );
}
